import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../../../../lib/api';

// Contratti quadro dell'insegna, tutti gli anni, in sola consultazione.
// Il clic sulla riga apre la pagina Contratto Quadro Insegna già posizionata
// su insegna e anno, dove si modificano.

interface Contratto {
  id: number;
  anno: number;
  descrizione: string;
  riepilogoAI: string | null;
  allegati: { id: number }[];
  updatedAt: string;
}

interface Props {
  insegnaId: number;
}

export default function TabContrattiInsegna({ insegnaId }: Props) {
  const navigate = useNavigate();
  const [contratti, setContratti] = useState<Contratto[]>([]);
  const [loading, setLoading] = useState(true);
  const [errore, setErrore] = useState('');

  useEffect(() => {
    let annullato = false;
    (async () => {
      setLoading(true);
      setErrore('');
      try {
        // @api GET /api/anagrafiche/contratti-insegna?insegnaClienteId=N -> [{"id":3,"anno":2026,"descrizione":"Accordo quadro 2026","riepilogoAI":"...","allegati":[{"id":7}],"updatedAt":"2026-03-02T10:00:00.000Z"}]
        const data = await apiFetch<Contratto[]>(`/api/anagrafiche/contratti-insegna?insegnaClienteId=${insegnaId}`);
        if (!annullato) setContratti(data || []);
      } catch (err: any) {
        if (!annullato) setErrore(err.message || 'Errore nel caricamento dei contratti');
      } finally {
        if (!annullato) setLoading(false);
      }
    })();
    return () => { annullato = true; };
  }, [insegnaId]);

  return (
    <div className="bop-card">
      <div className="bop-card__header">
        <h3 className="bop-card__title">Contratti quadro</h3>
      </div>
      <div className="bop-card__body">
        {loading ? (
          <div className="bop-empty-state"><p className="bop-empty-state__text">Caricamento…</p></div>
        ) : errore ? (
          <p className="bop-text-danger">{errore}</p>
        ) : contratti.length === 0 ? (
          <div className="bop-empty-state">
            <p className="bop-empty-state__text">Nessun contratto quadro per questa insegna</p>
          </div>
        ) : (
          <table className="bop-table bop-table--clickable">
            <thead>
              <tr>
                <th>Anno</th>
                <th>Descrizione</th>
                <th className="bop-text-right">Allegati</th>
                <th>Riepilogo AI</th>
                <th>Aggiornato il</th>
              </tr>
            </thead>
            <tbody>
              {contratti.map((c) => (
                <tr key={c.id} onClick={() => navigate(`/anagrafiche/insegne/contratti?insegna=${insegnaId}&anno=${c.anno}`)}>
                  <td><strong>{c.anno}</strong></td>
                  <td>{c.descrizione}</td>
                  <td className="bop-text-right">{c.allegati.length}</td>
                  <td>
                    {c.riepilogoAI
                      ? <span className="bop-badge bop-badge--success">Presente</span>
                      : <span className="bop-badge bop-badge--neutral">Assente</span>}
                  </td>
                  <td className="bop-text-muted">{new Date(c.updatedAt).toLocaleDateString('it-IT')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
